import FormattedMessage from 'I18n/components/FormattedMessage';
import { createActionCardCounters } from 'automation-ui-action-features/records/recordsUtils';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const EndMarkerLabel = ({
  flow,
  prevActionId
}) => {
  const countersMap = useMemo(() => createActionCardCounters(flow.actions, flow.getFirstActionId()), [flow]);
  const nodeNumber = prevActionId ? countersMap[prevActionId] : undefined;
  return nodeNumber ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation.historyModeEndMarker.endWorkflowText",
    options: {
      nodeId: nodeNumber
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation.historyModeEndMarker.emptyEndWorkflowText"
  });
};